/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApexOptions } from 'apexcharts';
import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';



interface ArayChartProps {
    series: {
        name: string;
        data: number[];
    }[];
}


const options: ApexOptions = {
    legend: {
        show: false,
        position: 'top',
        horizontalAlign: 'left',
    },
    colors: ['#F45095', '#FFAFBD'],
    chart: {
        fontFamily: 'Satoshi, sans-serif',
        height: 335,
        type: 'area',
        dropShadow: {
            enabled: true,
            color: '#623CEA14',
            top: 10,
            blur: 4,
            left: 0,
            opacity: 0.1,
        },

        toolbar: {
            show: false,
        },
    },
    responsive: [
        {
            breakpoint: 1024,
            options: {
                chart: {
                    height: 300,
                },
            },
        },
        {
            breakpoint: 1366,
            options: {
                chart: {
                    height: 350,
                },
            },
        },
    ],
    stroke: {
        width: [2, 2],
        curve: 'straight',
    },
    // labels: {
    //   show: false,
    //   position: "top",
    // },
    grid: {
        xaxis: {
            lines: {
                show: true,
            },
        },
        yaxis: {
            lines: {
                show: true,
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    markers: {
        size: 4,
        colors: '#fff',
        strokeColors: ['#F45095', '#FFAFBD'],
        strokeWidth: 3,
        strokeOpacity: 0.9,
        strokeDashArray: 0,
        fillOpacity: 1,
        discrete: [],
        hover: {
            size: undefined,
            sizeOffset: 5,
        },
    },
    xaxis: {
        type: 'category',
        categories: [
            'Sep',
            'Oct',
            'Nov',
            'Dec',
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
        ],
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        title: {
            style: {
                fontSize: '0px',
            },
        },
        min: 0,
        max: 100,
    },
};

const AreaChart: React.FC = () => {
    const [state, setState] = useState<ArayChartProps>({
        series: [
            {
                name: 'Services One',
                data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30, 45],
            },

            // {
            //   name: 'Product Two',
            //   data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39, 51],
            // },
        ],
    });

    return (
        <div className="col-span-12 rounded-md border bg-white px-3 py-5 shadow sm:px-3 xl:col-span-8">

            <div className="flex w-full justify-between items-center flex-wrap xs:flex-nowrap">

                <div className="flex w-full flex-wrap gap-3">
                    <div className="flex min-w-48 pl-2">
                        <span className="mt-1 mr-2 flex h-4 w-full max-w-4 items-center justify-center rounded-full border border-primary">
                            <span className="block h-2 w-full max-w-2 rounded-full bg-primary"></span>
                        </span>
                        <div className="w-full">
                            <p className="font-semibold text-primary">Total Refunds</p>
                            <p className="text-sm font-medium">12.04.2023 - 12.05.2024</p>
                        </div>
                    </div>
                    {/* <div className="flex min-w-47.5">
            <span className="mt-1 mr-2 flex h-4 w-full max-w-4 items-center justify-center rounded-full border border-secondary">
              <span className="block h-2.5 w-full max-w-2.5 rounded-full bg-secondary"></span>
            </span>
            <div className="w-full">
              <p className="font-semibold text-secondary">Total Sales</p>
              <p className="text-sm font-medium">12.04.2022 - 12.05.2022</p>
            </div>
          </div> */}
                </div>

                <div className="flex w-full max-w-44 justify-start xs:justify-end mx-5">
                    <div className="inline-flex items-center rounded-md bg-whiter p-1.5">
                        <button className="rounded bg-white py-1 px-3 text-xs font-medium text-black shadow hover:bg-white hover:shadow-md">
                            Monthly
                        </button>
                        {/* <button className="rounded py-1 px-3 text-xs font-medium text-black hover:bg-white hover:shadow-card">
              Week
            </button>
            <button className="rounded py-1 px-3 text-xs font-medium text-black hover:bg-white hover:shadow-card">
              Month
            </button> */}
                    </div>
                </div>
            </div>

            <div>
                <div id="chartOne" className="-ml-2">
                    <ReactApexChart
                        options={options}
                        series={state.series}
                        type="area"
                        height={350}
                    />
                </div>
            </div>
        </div>
    );
};

export default AreaChart;
